import { UseTableValue } from '@/common/types/UseTableValue.types';
import { useState } from 'react';

export default function useTable<T>(defaultParams: T): UseTableValue<T> {
  const [offset, setOffset] = useState<number>(0);
  const [params, setParams] = useState<T>(defaultParams);

  const handleChangeSorting = (sort: Map<string, boolean>): void => {
    setParams({
      ...params,
      offset: 0,
      sort: Object.fromEntries(sort),
    });
    setOffset(0);
  };

  const handleChangePage = (offset: number): void => {
    setParams({
      ...params,
      offset,
    });
    setOffset(offset);
  };

  return {
    handleChangeSorting,
    handleChangePage,
    offset,
    params,
    setParams,
    setOffset,
  };
}
